import React from 'react';
import styles from './radio-button.module.scss';

const RadioButton = ({ id, checked, onChange }) => {
  return (
    <label className={styles.label}>
      <input type="radio" id={id} className={styles.radio} checked={checked} onClick={e => onChange(e)} />
      <span className={styles.fake} />
    </label>
  );
};

export default RadioButton;
